import type { RouteObject } from 'react-router-dom';
import CollectionDetail from '../pages/CollectionDetail';
import CollectionMembersPage from '../pages/CollectionMembersPage';
import CreateCollection from '../pages/CreateCollection';
import MyCollections from '../pages/MyCollections';

export const collectionsRoutes: RouteObject[] = [
  { path: '/my-collections', element: <MyCollections /> },
  { path: '/collections', element: <div>All Collections (TODO)</div> },
  { path: '/collections/create', element: <CreateCollection /> },
  { path: '/collections/:id', element: <CollectionDetail /> },
  { path: '/collections/:id/members', element: <CollectionMembersPage /> },
  { path: '/collections/:id/edit', element: <div>Edit Collection (TODO)</div> },
];
